import { useState } from "react";
import { projectsDataEn, projectsDataAr } from "../data/projectsData";
import { useLanguage } from "../LanguageContext";

export default function ProjectsView({ navigate }) {
  const [activeFilter, setActiveFilter] = useState("all");
  const { isAr } = useLanguage();
  const t = (en, ar) => (isAr ? ar : en);
  const projectsData = isAr ? projectsDataAr : projectsDataEn;

  const FILTERS = [
    { label: t("All Projects",             "جميع المشاريع"),              value: "all" },
    { label: t("Cable Laying",             "مد الكابلات"),                value: "cable" },
    { label: "LST",                                                        value: "lst" },
    { label: t("Civil Engineering",        "الهندسة المدنية"),            value: "civil" },
    { label: t("Cable Infrastructure",     "البنية التحتية للكابلات"),   value: "infrastructure" },
    { label: t("Surveying Technology",     "تقنية المساحة"),              value: "surveying" },
  ];

  const availableFilters = FILTERS.filter(
    (filter) =>
      filter.value === "all" ||
      Object.values(projectsData).some((data) => data.tags?.includes(filter.value))
  );

  const filtered = Object.entries(projectsData).filter(([, data]) =>
    activeFilter === "all" ? true : data.tags.includes(activeFilter)
  );

  return (
    <div className="view-enter pt-24 sm:pt-28 md:pt-32 pb-12 sm:pb-16 md:pb-20 px-4 sm:px-6 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h3 className="text-axion-base font-bold tracking-widest uppercase mb-2 text-sm font-display">
            {t("Our Work", "أعمالنا")}
          </h3>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4 font-display">
            {t("Selected Projects", "مشاريع مختارة")}
          </h1>
          <h2 className="text-base sm:text-lg md:text-xl text-neutral-600 font-light max-w-xl md:max-w-2xl mx-auto font-display">
            {t(
              "Excellent implementation throughout Germany and Europe with strict safety and quality standards.",
              "تنفيذ ممتاز في جميع أنحاء ألمانيا وأوروبا بمعايير سلامة وجودة صارمة."
            )}
          </h2>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-nowrap sm:flex-wrap overflow-x-auto sm:overflow-visible justify-start sm:justify-center gap-2 sm:gap-4 md:gap-6 mb-10 sm:mb-12 md:mb-16 border-b border-gray-200 pb-4 -mx-4 px-4 sm:mx-0 sm:px-0 [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: "none" }}>
          {availableFilters.map(({ label, value }) => (
            <button
              key={value}
              onClick={() => setActiveFilter(value)}
              className={`filter-btn flex-shrink-0 whitespace-nowrap text-neutral-600 font-medium hover:text-primary-600 ${
                activeFilter === value ? "active text-primary-600 border-b-2 border-primary-600" : ""
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10">
          {filtered.map(([key, data]) => (
            <ProjectCard key={key} projectKey={key} data={data} navigate={navigate} isAr={isAr} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ProjectCard({ projectKey, data, navigate, isAr }) {
  const t = (en, ar) => (isAr ? ar : en);
  return (
    <div
      className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden interactive-card cursor-pointer group"
      onClick={() => navigate("project-detail", projectKey)}
    >
      <div className="h-48 sm:h-56 bg-gray-900 relative overflow-hidden">
        <img
          src={data.image}
          alt={data.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 text-xs font-bold text-axion-base rounded uppercase tracking-wider shadow-sm">
          {data.tagLabel}
        </div>
      </div>
      <div className="p-5 sm:p-6 md:p-8">
        <h3 className="text-lg sm:text-xl font-black text-gray-900 mb-2 sm:mb-3 line-clamp-2 font-display">
          {data.title}
        </h3>
        <p className="text-gray-500 font-light text-sm line-clamp-3 mb-6">{data.subtitle}</p>
        <span className="text-axion-base font-bold text-sm flex items-center gap-2 uppercase tracking-wide">
          {t("View Details", "عرض التفاصيل")}
          <i className={`ph-bold ${isAr ? "ph-arrow-left" : "ph-arrow-right"} arrow-icon`} />
        </span>
      </div>
    </div>
  );
}
